export default __webpack_public_path__ + "static/media/rental.205f7002.png";